import React from 'react';

const ViolationsContext = React.createContext({
  violations: '',
  setViolations: () => {},
});

export default ViolationsContext;
